import React from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';

const ResponsiveGridLayout = WidthProvider(Responsive);

const SarasDynamicGrid = (props) => {
    const { layoutConfig, children, deviceInfo } = props;

    const getRowHeight = () => {
        if (deviceInfo.activateMobileView) return 35; // Smaller on mobile
        if (deviceInfo.screenWidth > 1366) return 35; // Larger on big screens
        return 35; // Default
    };
    
    return(
        <ResponsiveGridLayout 
            isResizable={false} 
            isDraggable={false} 
            className="" 
            layouts={layoutConfig} 
            rowHeight={getRowHeight()}
            breakpoints={{ 
                lg: 1366,   // Standard laptop and above
                md: 1024,   // iPad landscape  
                sm: 768,    // iPad portrait
                xs: 480,    // Large phone landscape
                xxs: 0      // Phone portrait
            }}
            cols={{
                lg: 12,     // Desktop/laptop
                md: 12,     // Tablet landscape  
                sm: 12,      // Tablet portrait
                xs: 4,      // Phone landscape
                xxs: 4      // Phone portrait
            }}
            measureBeforeMount={true}
            useCSSTransforms={true}
            preventCollision={false}
            compactType="vertical"
            
        >
            {children}
        </ResponsiveGridLayout>
    )
}

export default SarasDynamicGrid